var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import moment from 'moment';
import { Location } from 'packages/location/Location';
var Job = /** @class */ (function (_super) {
    __extends(Job, _super);
    function Job() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.companyId = null;
        _this.cityId = null;
        _this.city = null;
        _this.location = new Location();
        _this.name = null;
        _this.description = null;
        _this.email = null;
        _this.slug = null;
        _this.externalApplyLink = null;
        _this.status = 'active';
        _this.activeFromDateTime = null;
        _this.activeToDateTime = null;
        _this.createdAt = null;
        _this.updatedAt = null;
        _this.formId = null;
        _this.isHidden = false;
        _this.applications = null;
        _this.numberOfUnreadMails = null;
        return _this;
    }
    Object.defineProperty(Job.prototype, "activeFrom", {
        get: function () {
            if (!this.activeFromDateTime) {
                return null;
            }
            return this.activeFromDateTime.format('YYYY-MM-DD');
        },
        set: function (value) {
            this.activeFromDateTime = value ? moment(value).startOf('day') : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Job.prototype, "activeTo", {
        get: function () {
            if (!this.activeToDateTime) {
                return null;
            }
            return this.activeToDateTime.format('YYYY-MM-DD');
        },
        set: function (value) {
            this.activeToDateTime = value ? moment(value).endOf('day') : null;
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Job.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (jsonData.active_from) {
            this.activeFrom = jsonData.active_from;
        }
        if (jsonData.active_to) {
            this.activeTo = jsonData.active_to;
        }
        if (jsonData.applications) {
            this.applications = jsonData.applications;
        }
        return this;
    };
    Job.prototype.toJson = function (toSnake, asString) {
        if (toSnake === void 0) { toSnake = true; }
        if (asString === void 0) { asString = false; }
        var json = _super.prototype.toJson.call(this, toSnake, false);
        json.active_from = this.activeFrom;
        json.active_to = this.activeTo;
        return asString ? JSON.stringify(json) : json;
    };
    var _a;
    __decorate([
        Type(Location),
        __metadata("design:type", typeof (_a = typeof Location !== "undefined" && Location) === "function" ? _a : Object)
    ], Job.prototype, "location", void 0);
    return Job;
}(Entity));
export { Job };
